import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import BlogDocument from './index';
import fetchBlogPost from '../../../modules/blog/fetchBlogPost';

class BlogDocumentContainer extends React.Component {
  componentWillMount() {
    const { params } = this.props.match;
    this.props.fetchBlogPost(params.id);
  }
  render() {
    return (
      <BlogDocument />
    )
  }
};

const mapActionToProps = {
  fetchBlogPost,
}

function stateTo(state) {
  return state
}

export default withRouter(connect(stateTo, mapActionToProps)(BlogDocumentContainer));




// WEBPACK FOOTER //
// ./src/pages/Admin/BlogDocument/container.js